module.exports = __webpack_public_path__ + "static/img/image.a34b69ba.png";